import React, {Component, createRef} from 'react';

import {Tooltip} from "@mui/material";

import TextInput from "../../../component/input/TextInput";
import SelectList from "../../../component/input/SelectList";
import RadioBtnList from "../../../component/input/RadioBtnList";
import SingleButton from "../../../component/button/SingleButton";

import * as messageUtil from "../../../util/messageUtil";
import * as dateUtil from "../../../util/dateUtil";
import * as stringUtil from "../../../util/stringUtil";
import * as apiUtil from "../../../util/apiUtil";

import button from "bootstrap/js/src/button";
import ButtonCountComp from "../../selfmessage/component/messagecreate/ButtonCountComp";
import CouponChargeComp from "../../../component/CouponChargeComp";

import recommendCss from '../recommend.module.css';
import Loading from "../../../component/loading/Loading";
import CampaignDateTimeInput from "../../../component/input/CampaignDateTimeInput";
import RecommendDateInput from "../../../component/input/RecommendDateInput";
import MessageMosuSelectModal from "../../../component/modal/MessageMosuSelectModal";
import MessageMapticsModal from "../../../component/modal/MessageMapticsModal";

import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import {Navigation} from "swiper/modules";

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as recommendAction from "../store/recommend";
import ImageSelectModal from "../../../component/modal/ImageSelectModal";
import ImageAddModal from "../../selfmessage/image/component/ImageAddModal";
import { RCS_TYPES, isRcsText, rcsImageSizes, rcsSizeLabel, rcsImageSizeLimitLabel, validateRcsFile } from "../../../util/rcsTypeUtil";
import MessageSavedModal from "../../../component/modal/MessageSavedModal";
import {
    applyRecommendScheduleChange,
    createRecommendDefaultSchedule,
    compareDateTimes,
    getCollectionDeadline,
    getRecommendScheduleLimits,
    isNonBusinessDay,
    toApiDateTime,
} from '../../../util/campaignScheduleUtil';

class RecommendContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoadingMosu = this.setLoadingMosu.bind(this);
        this.setLoadingUserInfo = this.setLoadingUserInfo.bind(this);
        this.setLoadingCategory = this.setLoadingCategory.bind(this);
        this.setLoadingMsgList = this.setLoadingMsgList.bind(this);
        this.setLoadingCreate = this.setLoadingCreate.bind(this);

        this.setValue = this.setValue.bind(this);
        this.setVariable = this.setVariable.bind(this);
        this.setUrl = this.setUrl.bind(this);
        this.setButtonInfo = this.setButtonInfo.bind(this);
        this.setButtonCount = this.setButtonCount.bind(this);

        this.messageSelect = this.messageSelect.bind(this);
        this.handleCouponChange = this.handleCouponChange.bind(this);

        this.ajaxGetMessageList = this.ajaxGetMessageList.bind(this);
        this.ajaxGetRecommendCategoryMap = this.ajaxGetRecommendCategoryMap.bind(this);
        this.ajaxGetUserMessageInfo = this.ajaxGetUserMessageInfo.bind(this);
        this.ajaxResetAtsMosu = this.ajaxResetAtsMosu.bind(this);
        this.ajaxCreateMessage = this.ajaxCreateMessage.bind(this);
        this.setMosuData = this.setMosuData.bind(this);
        this.checkAtsMosuAndCreate = this.checkAtsMosuAndCreate.bind(this);

        this.openMosuSelectModal = this.openMosuSelectModal.bind(this);
        this.handleMosuSelectModal = this.handleMosuSelectModal.bind(this);
        this.handleMapticsModal = this.handleMapticsModal.bind(this);
        this.setMapticsData = this.setMapticsData.bind(this);
        this.ajaxCreateMaptics = this.ajaxCreateMaptics.bind(this);

        this.handleSavedModal = this.handleSavedModal.bind(this);
        this.setIsAIImage = this.setIsAIImage.bind(this);

        // 이미지 관련
        this.changePreview = this.changePreview.bind(this);
        this.openImageListModal = this.openImageListModal.bind(this);
        this.closeImageListModal = this.closeImageListModal.bind(this);
        this.handleImageUploadModal = this.handleImageUploadModal.bind(this);
        this.checkFileName = this.checkFileName.bind(this);

        this.ajaxGetImageList = this.ajaxGetImageList.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);

        this.handleCPInput = this.handleCPInput.bind(this);
        this.handleRCSFile = this.handleRCSFile.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);

        this.handleRCSTypeChange = this.handleRCSTypeChange.bind(this);

        this.getEmptyKeys = this.getEmptyKeys.bind(this);

        this.detailsRef = createRef();
        this.imageButtonRef =  React.createRef();

        this.state = {
            loadingMosu: false,
            loadingUserInfo: false,
            loadingCategory: false,
            loadingMsgList: false,
            loadingCreate: false,

            loadingText: '',

            mode: "INIT",
            mosuSelectModalOpen: false,

            mapticsModalOpen: false,

            savedModalOpen: false,

            // 이미지 관련
            imageListModal: false,
            imageUploadModal: false,

            imageList: [],
            page: 1,
            size: 10,
            sort: 'date',
            total: 0,
            preview: null,
            isAIImage: false,

            defaultMessageDetail: {
                uid: 0,
                name: '',
                rcsTitle: '',
                rcsMessage: '',
                callback: '',
                sndNum: '',
            },

        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.page !== nextProps.page
            || this.props.size !== nextProps.size
            || this.props.total !== nextProps.total
            || this.props.mosuCnt !== nextProps.mosuCnt
            || this.props.mosuCntInit !== nextProps.mosuCntInit
            || this.props.couponList !== nextProps.couponList
            || this.props.selectedCoupon !== nextProps.selectedCoupon
            || this.props.cashAmount !== nextProps.cashAmount
            || this.props.freeAmount !== nextProps.freeAmount
            || this.props.txtMessageUnit !== nextProps.txtMessageUnit
            || this.props.imgMessageUnit !== nextProps.imgMessageUnit
            || this.props.groupedMessages !== nextProps.groupedMessages
            || this.props.messageDetail !== nextProps.messageDetail
            || this.props.variableMap !== nextProps.variableMap
            || this.props.urlMap !== nextProps.urlMap
            || this.props.buttonCount !== nextProps.buttonCount
            || this.props.buttonInfo !== nextProps.buttonInfo
            || this.props.sendNumber !== nextProps.sendNumber
            || this.props.sendDate !== nextProps.sendDate
            || this.props.sendType !== nextProps.sendType
            || this.props.gmType !== nextProps.gmType
            || this.props.gmTypeList !== nextProps.gmTypeList
            || this.props.bgmType !== nextProps.bgmType
            || this.props.bgmTypeList !== nextProps.bgmTypeList

            || this.props.RCSType !== nextProps.RCSType
            || this.props.rcsType !== nextProps.rcsType
            || this.props.billingType !== nextProps.billingType
            || this.props.messageType !== nextProps.messageType

            || this.props.rcsImgOrigId !== nextProps.rcsImgOrigId
            || this.props.mmsImgOrigId !== nextProps.mmsImgOrigId
            || this.props.messageType !== nextProps.messageType
            || this.props.RCSFile !== nextProps.RCSFile
            || this.props.MMSFile !== nextProps.MMSFile
            || this.props.imgName !== nextProps.imgName

            || this.state.preview !== nextState.preview
            || this.state.page !== nextState.page
            || this.state.size !== nextState.size
            || this.state.imageList !== nextState.imageList
            || this.state.imageUploadModal !== nextState.imageUploadModal
            || this.state.imageListModal !== nextState.imageListModal
            || this.state.total !== nextState.total

            || this.state.loadingMosu !== nextState.loadingMosu
            || this.state.loadingUserInfo !== nextState.loadingUserInfo
            || this.state.loadingCategory !== nextState.loadingCategory
            || this.state.loadingMsgList !== nextState.loadingMsgList
            || this.state.loadingCreate !== nextState.loadingCreate
            || this.state.loadingText !== nextState.loadingText
            || this.state.alertOpen !== nextState.alertOpen
            || this.state.alertMessage !== nextState.alertMessage
            || this.state.alertButtons !== nextState.alertButtons
            || this.state.mosuSelectModalOpen !== nextState.mosuSelectModalOpen
            || this.state.mapticsModalOpen !== nextState.mapticsModalOpen
            || this.state.savedModalOpen !== nextState.savedModalOpen

            || this.props.targetType !== nextProps.targetType
            || this.props.mapticsSendType !== nextProps.mapticsSendType
            || this.props.collStartDate !== nextProps.collStartDate
            || this.props.collEndDate !== nextProps.collEndDate
            || this.props.collSndDate !== nextProps.collSndDate
            || this.props.rtEndHour !== nextProps.rtEndHour
            || this.props.rtEndMinute !== nextProps.rtEndMinute
            || this.props.mapticsData !== nextProps.mapticsData
            || this.props.mapticsTargetId !== nextProps.mapticsTargetId

            || this.props.createdCampaignUid !== nextProps.createdCampaignUid
            || this.state.isAIImage !== nextState.isAIImage
        )
    }

    componentDidMount() {
        this.props.RecommendAction.setSchedule(createRecommendDefaultSchedule());
        this.ajaxGetUserMessageInfo();
        this.ajaxGetRecommendCategoryMap();
    }

    /* setter */
    setLoadingMosu(loading, text) {
        this.setState({ loadingMosu: loading, loadingText: text });
    }
    setLoadingUserInfo(loading) {
        this.setState({ loadingUserInfo: loading });
    }
    setLoadingCategory(loading) {
        this.setState({ loadingCategory: loading });
    }
    setLoadingMsgList(loading) {
        this.setState({ loadingMsgList: loading });
    }
    setLoadingCreate(loading) {
        this.setState({ loadingCreate: loading });
    }
    setIsAIImage(isChecked) {
        this.setState({ isAIImage: isChecked });
    }

    async setValue(id, value) {
        const { RecommendAction } = this.props;
        const { targetType, mapticsSendType, sendDate, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute, gmTypeList } = this.props;
        const { defaultMessageDetail} = this.state;

        const schedule = {
            targetType,
            mapticsSendType,
            sendDate,
            collStartDate,
            collEndDate,
            collSndDate,
            rtEndHour,
            rtEndMinute,
        };

        switch(id) {
            case "targetType":
            case "mapticsSendType":
            case "sendDate":
            case "collStartDate":
            case "collEndDate":
            case "collSndDate":
            case "rtEndHour":
            case "rtEndMinute":
                if (id === 'collSndDate' && isNonBusinessDay(value)) {
                    alert("발송 일자를 주말, 공휴일로 설정 하셨습니다.\n 주말 및 공휴일 발송 시 기재하신 고객센테에서 CS 처리가 가능하여야 합니다.");
                }
                RecommendAction.setSchedule(applyRecommendScheduleChange(schedule, id, value));
                break;
            case "sendNumber":
                RecommendAction.setSendNumber(value);
                break;
            case "gmType":
                const selectedCategory = value === '' ? '' : JSON.parse(value);
                await RecommendAction.setGMType(selectedCategory);
                RecommendAction.setMessageDetail(defaultMessageDetail);
                RecommendAction.setGroupedMessages([]);
                if(selectedCategory && selectedCategory.uid) this.ajaxGetMessageList(selectedCategory.uid);
                break;
            case "bgmType":
                const selectedBaseCategory = value === '' ? '' : JSON.parse(value);
                const firstCategory = selectedBaseCategory
                    ? gmTypeList.find((item) => item.baseCategoryUid === selectedBaseCategory.uid)
                    : null;

                await RecommendAction.setBGMType(selectedBaseCategory);
                await RecommendAction.setGMType(firstCategory || '');
                RecommendAction.setMessageDetail(defaultMessageDetail);
                RecommendAction.setGroupedMessages([]);
                if(firstCategory) this.ajaxGetMessageList(firstCategory.uid);
                break;
        }
    }
    setVariable(id, value) {
        const { RecommendAction } = this.props;
        if(id === '업체명') {
            if(value.length > 10) {
                alert("업체명은 10글자까지만 가능합니다!")
                value = value.slice(0, 10);
            }
        }
        RecommendAction.setVariableMap({ key: id, value: value });
    }
    setUrl(id, value) {
        const { RecommendAction } = this.props;
        RecommendAction.setUrlMap({ key: id, value: value });
    }
    setButtonInfo(id, value) {
        const { RecommendAction } = this.props;
        const coordinate = id.split("_");

        if (coordinate[0] === 'name') {
            if (value.length > 17) {
                alert("버튼 이름은 17자까지만 가능합니다!");
                value = value.slice(0, 17);
            }
        }

        RecommendAction.setButtonCoordinate({ key: coordinate[0], index: coordinate[1], value: value });
    }
    setButtonCount(value) {
        const { RecommendAction } = this.props;
        let { buttonInfo } = this.props;

        if (value.length === 0) {
            buttonInfo = [];
        } else if (value.length > buttonInfo.length) {
            // 선택된 개수가 더 많으면 부족한 만큼 추가
            const toAdd = value.length - buttonInfo.length;
            const newButtons = Array.from({ length: toAdd }, () => ({
                type: 'WEB', name: '', val1: 'https://', val2: '',
            }));
            buttonInfo = [...buttonInfo, ...newButtons];
        } else if (value.length < buttonInfo.length) {
            // 선택된 개수가 더 적으면 뒤에서부터 제거
            buttonInfo = buttonInfo.slice(0, value.length);
        }

        RecommendAction.setButtonCount(value);
        RecommendAction.setButtonInfo(buttonInfo);
    }

    /* handlers */
    async messageSelect(message) {
        const { RecommendAction } = this.props;
        RecommendAction.setMessageDetail(message);

        // 캠페인 생성 시 서버가 템플릿 전체를 다시 치환하므로, RCS/MMS 제목·본문의 변수를 모두 수집한다.
        const templateParts = [message.mmsTitle, message.mmsMessage, message.rcsTitle, message.rcsMessage];
        const variables = templateParts.reduce((result, value) => ({...result, ...stringUtil.extractVariables(value || '')}), {});
        const urls = templateParts.reduce((result, value) => ({...result, ...stringUtil.extractUrls(value || '')}), {});
        await RecommendAction.initVariableMap(variables);
        await RecommendAction.initUrlMap(urls);

        this.detailsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    async handleCouponChange(e) {
        const { RecommendAction } = this.props;
        const { sendNumber } = this.props;

        const value = e.target.value;
        if(value === '') {
            await RecommendAction.setSelectedCoupon({});
            return;
        }

        const parsedValue = JSON.parse(value);
        if(parsedValue.amount > sendNumber) {
            alert('목표발송건수를 초과하는 쿠폰은 사용할 수 없습니다.');
            return;
        }

        await RecommendAction.setSelectedCoupon(parsedValue);
    }

    getEmptyKeys(variableMap, urlMap) {
        const emptyVariableKeys = Object.keys(variableMap).filter(key => {
            const v = variableMap[key];

            if (key.startsWith("기간")) {
                return this.isEmptyPeriod(v);   // 기간만 특별 처리
            }

            return (
                v === null ||
                v === undefined ||
                (typeof v === "string" && v.trim() === "")
            );
        });

        const emptyUrlKeys = Object.keys(urlMap).filter(key => {
            const v = urlMap[key];

            // URL 분석 조건
            return (
                v === null ||
                v === undefined ||
                (typeof v === "string" && (
                    v.trim() === "" ||
                    v.trim() === "http://" ||
                    v.trim() === "https://"
                ))
            );
        });
        return [...emptyVariableKeys, ...emptyUrlKeys];
    }

    isEmptyPeriod(value) {
        if (!value || typeof value !== "string") return true;

        // 년이 있는 날짜: 2025년 3월 1일(토)
        const DATE_FULL = /^[0-9]{4}년\s*[0-9]{1,2}월\s*[0-9]{1,2}일\([일월화수목금토]\)$/;

        // 년이 없는 날짜: 3월 1일(토)
        const DATE_NO_YEAR = /^[0-9]{1,2}월\s*[0-9]{1,2}일\([일월화수목금토]\)$/;

        const [start, end] = value.split("~").map(s => s.trim());

        // 둘 중 하나라도 없음 → 미완성
        if (!start || !end) return true;

        // 템플릿 기본값 체크
        if (start.includes("년 월 일") || end.includes("년 월 일")) return true;

        // 시작(start)은 반드시 FULL형식이어야 함
        if (!DATE_FULL.test(start)) return true;

        // 종료(end)는 full 또는 no-year 모두 허용
        if (!(DATE_FULL.test(end) || DATE_NO_YEAR.test(end))) return true;

        return false;
    }

    checkAtsMosuAndCreate() {
        const { buttonCount, buttonInfo, mosuCnt, sendNumber, targetType, mapticsSendType, mapticsData, collStartDate, collEndDate, collSndDate, variableMap, urlMap } = this.props;

        let confirmMessage = "메시지를 등록하시겠습니까?";

        if (targetType === "ATS") {
            const recommendedCount = Math.round(sendNumber * 1.5);
            confirmMessage += "\n\n- 목표 발송 건수가 추출한 모수보다 권장 건수 미만으로 메시지가 발송 될 경우, 목표발송 건수에 미도달 할 수도 있습니다.\n" +
                "- 권장 건수 : " + sendNumber + " * 1.5 = " + recommendedCount + "건";
        }

        if (!window.confirm(confirmMessage)) return;

        const emptyKeys = this.getEmptyKeys(variableMap, urlMap);

        if (emptyKeys.length > 0) {
            alert(`${emptyKeys.join(", ")} 이(가) 비어 있습니다.\n필수 기입 사항이 누락되진 않았는지 재확인 부탁드립니다.`);
            return;
        }

        if(buttonCount.length > 0 && buttonInfo.length > 0) {
            for (let btn of buttonInfo) {
                const value = btn?.val1;
                const name = btn?.name;
                const val2 = btn?.val2;
                const type = btn?.type;
                if (
                    value === null ||
                    value === undefined ||
                    (typeof value === "string" && ((type !== 'MAP' && (value.trim() === "" || value.trim() === "https://" || value.trim() === "http://"))
                                                    || (type === 'MAP' && value.trim() === ""))
                    )
                ) {
                    alert("버튼 입력값 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }
                if (name === null || name === undefined || name.trim() === "") {
                    alert("버튼명 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }
                if (type === 'MAP' && (val2.trim() === "" || val2.trim() === "https://" || val2.trim() === "http://")) {
                    alert("버튼 입력값 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }

            }
        }

        if (targetType === "ATS") {
            const mCnt = Number(mosuCnt);
            const sNum = Number(sendNumber);
            if(  mCnt < sNum ) {
                alert('발송 가능 대상이 발송 희망 건수보다 작습니다. 발송 가능 대상을 조절하거나 발송 희망 건수를 조절해주세요.');
                return;
            }

            if (mosuCnt > 400000) {
                this.ajaxResetAtsMosu();
            } else if (mosuCnt > 0 && mosuCnt <= 400000) {
                const mCnt = Number(mosuCnt);
                const sNum = Number(sendNumber);
                if(mosuCnt < 1000 && mCnt !== sNum) {
                    alert('발송 가능 대상이 1000명 이하인 경우 발송 희망 건수와 발송 가능 대상은 동일해야합니다.');
                    return;
                } else if ( mCnt >= 1000 && sNum < 1000 ) {
                    alert('발송 가능 대상이 1000명 이상인 경우 발송 희망 건수는 최소 1000건 이상 설정해야합니다.');
                    return;
                }

                this.ajaxCreateMessage();
            } else {
                alert('발송 가능 대상 조회 버튼을 눌러 모수조회를 먼저 진행하여야 합니다.');
            }
        } else if (targetType === "MAPTICS") {
            if (mapticsSendType === 'maptics_collect') {
                if (compareDateTimes(collStartDate, collEndDate) >= 0) {
                    alert("수집 기간의 종료 일정이 시작 일정보다 이전으로 설정되어 있습니다.\n올바른 발송 일정을 다시 설정해 주세요.");
                    return;
                }

                const collectionDeadline = getCollectionDeadline(collSndDate);
                if (compareDateTimes(collEndDate, collectionDeadline) > 0) {
                    alert("수집 종료는 발송 시각 10분 전까지 설정할 수 있습니다.");
                    return;
                }

                if (compareDateTimes(collEndDate, collStartDate) < 10 * 60 * 1000) {
                    alert("수집 기간은 최소 10분 이상 설정해 주세요.");
                    return;
                }
            } else if (mapticsSendType === 'maptics_realtime') {
                if (collStartDate >= collEndDate) {
                    alert("발송 기간의 종료 시각이 시작 시각보다 이전으로 설정되어 있습니다.\n올바른 발송 시각을 다시 설정해주세요.");
                    return;
                }
            }

            if(sendNumber < 1000) {
                alert("최소 발송 건수는 1000건입니다.");
                return;
            }

            this.ajaxCreateMaptics(mapticsData);
        }
    }

    async ajaxCreateMaptics(mapticsData) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/maptics/create",
            method: apiUtil.requestMethod.POST,
            data: mapticsData,
            success: async (result) => {
                const { RecommendAction } = this.props;
                await RecommendAction.setMapticsTargetId(result);

                await this.ajaxCreateMessage();
            }
        });
    }

    setMosuData(data) {
        const { mode } = this.state;
        const { RecommendAction } = this.props;

        if (mode === "RESET") {
            RecommendAction.setMosuCnt(data.cnt);
            RecommendAction.setMosuQuery(data.query);
            RecommendAction.setMosuDesc(data.filterStr);
            RecommendAction.setMosuJson(data.mosuJson);
        } else if (mode === "INIT") {
            RecommendAction.setMosuCntInit(data.cnt);
        }
    }

    ajaxResetAtsMosu() {
        const { mosuJson, mosuCnt } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoadingMosu,
            loadingText: '발송 요청 수보다 추출된 모수가 너무 많아 40만 이하로 자동 조정됩니다.',
            url: "/api/category/ats/mosu/reset",
            method: apiUtil.requestMethod.POST,
            data: {
                mosuCnt: mosuCnt,
                mosuJson: mosuJson,
            },
            success: async (result) => {
                const { RecommendAction } = this.props;

                await RecommendAction.setMosuCnt(result.cnt);
                await RecommendAction.setMosuQuery(result.query);
                await RecommendAction.setMosuDesc(result.filterStr);
                await RecommendAction.setMosuJson(result.mosuJson);

                this.ajaxCreateMessage();
            }
        });
    }

    //이미지 관련
    // 2026-03-18 fix: {…this.state} 스프레드 제거 - Safari 무한 로딩 버그 수정
    changePreview(url) {
        this.setState({ preview: url });
    }

    closeImageListModal(){ this.setState({ imageListModal: false }) }
    openImageListModal(){ this.setState({ imageListModal: true }, () => this.ajaxGetImageList()) }

    handleImageUploadModal() {
        const { imageUploadModal } = this.state;
        this.setState({ imageUploadModal: !imageUploadModal })
    }

    checkFileName() {
        const { imgName } = this.props;
        if (! imgName) {
            alert('이미지명이 입력되지 않았습니다.');
            return false;
        }

        this.handleImageUploadModal();
        return true;
    }

    clearFileInput() {
        // this.fileInputRef.current.value = '';
    }// end clearfileinput

    ajaxGetImageList(){
        const { page, size, sort } = this.state;
        const requestType = this.props.rcsType;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/list",
            method: apiUtil.requestMethod.POST,
            data: {
                imgType: "RCS",
                sizes: rcsImageSizes(requestType),
                rcsType: Number(requestType),
                sort: sort,
                page: page,
                size: size,
            },
            success: async (result) => {
                if (this.props.rcsType !== requestType || this.state.page !== page) return;
                this.setState({ imageList: result.content, total: result.total });
            }
        })
    }// end ajaxGetImageList
    handlePageChange (value) {
        this.setState({ page: value }, () => this.ajaxGetImageList());
    }
    async handleCPInput(id, value) {
        const { RecommendAction, RCSInfo, RCSFile } = this.props;
        switch(id) {
            case "imgName":
                await RecommendAction.setImgName(value);
                break;
            case "imgFile":
                await this.handleFileChange(value);
                break;
            default:
                break;
        }// end switch
    }// end handleSendDate

    async handleFileChange(file) {
        const { RecommendAction } = this.props;
        const type = this.props.rcsType;
        if (!(await validateRcsFile(file, type)) || this.props.rcsType !== type) return;
        this.handleRCSFile(file);
        // const file = e.target.files[0];
        if (file) {
            // await SelfAction.setRcsInfoImgOrigId('', index);
            await RecommendAction.setRcsInfoImgOrigId('', 0);
            const objectUrl = URL.createObjectURL(file);
            this.setState({ preview: objectUrl });
        }
    }// end handleFileChange
    async handleRCSFile(file) {
        const { RecommendAction, selectedSlide } = this.props;
        await RecommendAction.setRCSFile(0, file);
        await RecommendAction.setMMSFile(file);
    }// end handleMainFile

    // "발송 서비스 선택시 동작"
    async handleRCSTypeChange(id, value) {
        /*RCS type 변경시 rcsType, billingType 변경*/
        const { RecommendAction } = this.props;
        const type = Number(value);
        if (!RCS_TYPES.some(item => item.value === type) || Number(this.props.rcsType) === type) return;
        this.setState({ isAIImage: false, preview: null, imageListModal: false, imageUploadModal: false, imageList: [], page: 1 });
        await RecommendAction.setRCSFile(0, null);
        await RecommendAction.setMMSFile(null);
        await RecommendAction.setRcsInfoImgOrigId('', 0);
        await RecommendAction.setMmsFileOrigId('', 0);
        await RecommendAction.setImgName('');
        RecommendAction.setRcsType(isRcsText(type) ? '텍스트' : '이미지');
        if (isRcsText(type)){
            await RecommendAction.setMessageType("일반 문자메시지-텍스트");
            await RecommendAction.setBillingType(3);
            await RecommendAction.setrcsType(type);
        } else {
            await RecommendAction.setMessageType("일반 문자메시지-이미지");
            await RecommendAction.setBillingType(1);
            await RecommendAction.setrcsType(type);
        }
    } // end RCSType ==> [이미지, 텍스트]


    /* ajax request methods */
    ajaxCreateMessage() {
        const { mosuCnt, mosuQuery, mosuDesc, mosuJson } = this.props;
        const { targetType, mapticsSendType, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute, mapticsTargetId } = this.props;
        const { messageDetail, sendNumber, sendDate, sendType, variableMap, urlMap, buttonInfo } = this.props;
        const { selectedCoupon } = this.props;

        const { RCSFile, MMSFile, imgName, rcsType, rcsImgOrigId, mmsImgOrigId, messageType, billingType } = this.props;
        const { isAIImage } = this.state;

        let rcvType1 = 0;
        let collEndDate1 = collEndDate;
        if (targetType === 'ATS') {
            rcvType1 = 0;

            if(mosuCnt < sendNumber) {
                alert("목표 발송 대상의 수가 발송 희망 건수보다 작습니다. 목표 발송 대상 필터를 변경하거나 발송 희망 건수를 변경해주세요.");
                return;
            }

        } else if (targetType === 'MAPTICS') {
            if (mapticsSendType === 'maptics_collect') {
                rcvType1 = 2;
            } else if (mapticsSendType === 'maptics_realtime') {
                rcvType1 = 1;
            }
        }

        let data = new FormData();
        // rcsType으로 이미지인지 텍스트인지 확인

        if(!isRcsText(rcsType)){
            for(let i = 0; i < RCSFile?.length; i++){
                data.append("RCSFile", RCSFile[i]);
            }
            data.append("MMSFile", MMSFile);
        }else{
            data.append("RCSFile", null);
            data.append("MMSFile", null);
        }

        let data2 = {
            messageId: messageDetail.uid,
            mosuCnt: rcvType1 === 0 ? mosuCnt : null,
            mosuQuery: rcvType1 === 0 ? mosuQuery : null,
            mosuDesc: rcvType1 === 0 ? mosuDesc : null,
            mosuJson: rcvType1 === 0 ? mosuJson : null,
            variable: variableMap,
            urlList: Object.values(urlMap),
            buttons: buttonInfo,
            sendNumber: sendNumber,
            sendDate: rcvType1 === 0 ? toApiDateTime(sendDate) : null,
            sendType: sendType,
            couponId: selectedCoupon.uid,

            rcvType: rcvType1,
            collStartDate: (rcvType1 === 1 || rcvType1 === 2) ? toApiDateTime(collStartDate) : null,
            collEndDate: (rcvType1 === 1 || rcvType1 === 2) ? toApiDateTime(collEndDate) : null,
            collSndDate: rcvType1 === 2 ? toApiDateTime(collSndDate) : null,
            rtStartHhmm: rcvType1 === 1 ? collStartDate.substr(11, 2) + collStartDate.substr(14,2) : null,
            rtEndHhmm: rcvType1 === 1 ? rtEndHour + rtEndMinute : null,
            sndGeofenceId: (rcvType1 === 1 || rcvType1 === 2) ? mapticsTargetId : null,
            imgName: imgName,
            rcsType: rcsType,
            rcsImgOrigId: rcsImgOrigId.value,
            mmsImgOrigId: mmsImgOrigId.value,
            messageType: messageType,
            billingType: billingType,
            isAIImage: isAIImage,
        }

        data.append('request', JSON.stringify(data2));

        apiUtil.asyncRequest({
            setLoading: this.setLoadingCreate,
            url: "/api/bizchat/message/create/recommend",
            method: apiUtil.requestMethod.POST,
            data: data,
            isFile: true,
            success: (result) => {
                if (result.uid) {
                    const { RecommendAction } = this.props;
                    RecommendAction.setCreatedCampaignUid(result.uid);

                    this.handleSavedModal();
                }
            }
        })
    }
    ajaxGetUserMessageInfo() {
        const { RecommendAction } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoadingUserInfo,
            url: "/api/bizchat/user/info/message",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                RecommendAction.setCouponList(result.couponList);
                RecommendAction.setCashAmount(result.amount);
                RecommendAction.setFreeAmount(result.freeAmount);
                RecommendAction.setTxtMessageUnit(result.txtMessageUnit);
                RecommendAction.setImgMessageUnit(result.imgMessageUnit);
            }
        })
    }
    ajaxGetMessageList(categoryUid) {
        apiUtil.asyncRequest({
            setLoading: this.setLoadingMsgList,
            url: "/api/bizchat/message/approved/list/"+categoryUid,
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                const { RecommendAction } = this.props;
                RecommendAction.setGroupedMessages(result);
                // RecommendAction.setTotal(result.total);
            }
        })
    }
    ajaxGetRecommendCategoryMap() {
        apiUtil.asyncRequest({
            setLoading: this.setLoadingCategory,
            url: `/api/bizchat/message/recommend/category-map/list`,
            method: apiUtil.requestMethod.POST,
            success: (categoryMap) => {
                const { RecommendAction } = this.props;
                const baseCategoryList = categoryMap || [];
                const categoryList = baseCategoryList.flatMap((baseCategory) => baseCategory.categories || []);
                const firstBaseCategory = baseCategoryList.find((baseCategory) => baseCategory.categories && baseCategory.categories.length > 0)
                    || baseCategoryList[0]
                    || '';
                const firstCategory = firstBaseCategory && firstBaseCategory.categories.length > 0
                    ? firstBaseCategory.categories[0]
                    : '';

                RecommendAction.setBGMTypeList(baseCategoryList);
                RecommendAction.setGMTypeList(categoryList);
                RecommendAction.setBGMType(firstBaseCategory);
                RecommendAction.setGMType(firstCategory);
                RecommendAction.setMessageDetail(this.state.defaultMessageDetail);
                RecommendAction.setGroupedMessages([]);

                if(firstCategory) this.ajaxGetMessageList(firstCategory.uid);
            }
        })
    }

    openMosuSelectModal(mode) {
        this.setState({ mode: mode });
        this.handleMosuSelectModal();
    }

    handleMosuSelectModal() {
        const { mosuSelectModalOpen }  = this.state;
        this.setState({ mosuSelectModalOpen: ! mosuSelectModalOpen });
    }

    handleMapticsModal() {
        const { mapticsModalOpen } = this.state;
        this.setState({ mapticsModalOpen: ! mapticsModalOpen });
    }

    setMapticsData(mapticsData) {
        const { RecommendAction } = this.props;
        RecommendAction.setMapticsData(mapticsData);
    }

    handleSavedModal() {
        const { savedModalOpen } = this.state;

        if (savedModalOpen) {
            this.setState({ savedModalOpen: ! savedModalOpen });
            window.location.href = "/sent/list"
        } else {
            this.setState({ savedModalOpen: ! savedModalOpen });
        }
    }

    render() {
        const { loadingMosu, loadingUserInfo, loadingCategory, loadingMsgList, loadingCreate, loadingText } = this.state;

        const { targetType } = this.props;
        const { mosuCnt, mosuCntInit, groupedMessages } = this.props;
        const { mapticsSendType, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute } = this.props;
        const scheduleLimits = getRecommendScheduleLimits({
            targetType,
            mapticsSendType,
            sendDate: this.props.sendDate,
            collStartDate,
            collEndDate,
            collSndDate,
            rtEndHour,
            rtEndMinute,
        });

        const { couponList, selectedCoupon, cashAmount, freeAmount, txtMessageUnit, imgMessageUnit } = this.props;
        const { handleCouponChange } = this;

        const { messageDetail, sendNumber, sendDate, variableMap, urlMap, buttonCount, buttonInfo, gmType, gmTypeList, bgmType, bgmTypeList } = this.props;

        const { messageSelect, setValue, setVariable, setUrl, setButtonCount, setButtonInfo, checkAtsMosuAndCreate, setMosuData } = this;

        const { mosuSelectModalOpen, mapticsModalOpen } = this.state;
        const { openMosuSelectModal, handleMosuSelectModal, handleMapticsModal, setMapticsData } = this;

        const { handleSavedModal, setIsAIImage } = this;
        const { savedModalOpen } = this.state;
        const { createdCampaignUid } = this.props;

        const { preview, isAIImage } = this.state;
        const { RCSType, billingType, imgName } = this.props;
        const { RecommendAction } = this.props;
        const { imageListModal, imageUploadModal, imageList, total, size, page, brandName, eventContent, eventFrom, eventTo, eventUrl, eventWarning, customerCenter } = this.state;
        const { openImageListModal, closeImageListModal, handleImageUploadModal, handlePageChange, checkFileName, changePreview, handleCPInput, handleRCSTypeChange } = this;
        return (
            <React.Fragment>
                <Loading
                    loading={loadingMosu || loadingUserInfo || loadingCategory || loadingMsgList || loadingCreate}
                    text={loadingText}
                />
                <div className='container-xxl pb-3 gy-5'>
                    <h2 className='fs-4'>추천 메시지 발송</h2>

                    <div className='info-content-item shadow'>
                        <h5 className='fs-5 d-flex align-items-center'>
                            <span className="material-symbols-outlined text-primary fs-4 pe-2 fw-bold">info</span>
                            <span>추천 메시지 발송</span>
                        </h5>
                        <ol className='fs-6 mb-0 fw-normal fs-4 ps-3 ps-sm-5 '>
                            <li>즉발성 메시지가 아닌 예약 발송 형태의 메시지입니다.</li>
                            <li>사전 승인 완료된 메시지를 활용하여 마케팅 메시지를 발송할 수 있습니다.</li>
                            <li>메시지 내 가변영역을 업체에 맞게 작성하여 발송이 가능합니다.</li>
                            <li>가변 영역은 10자 이하로 활용 가능하며, 가변 영역에 내용에 따라 발송 요청이 반려될 수 있습니다.</li>
                            <li>메시지 발송 시 희망하는 타겟 연령을 설정하여 발송이 가능합니다.</li>
                            <li style={{color: 'red', wordBreak: 'keep-all'}}>
                                분양 광고는 반드시 <strong>1:1 문의</strong> 부탁드립니다. 비즈팅 사이트 내에서는 분양광고 진행이 어려우며, <strong>대행발송으로 진행</strong>되는 점 참고 부탁드립니다. <strong>포인트 충전 전 반드시 확인 부탁드립니다.</strong>
                            </li>
                        </ol>
                    </div>

                    <section className={`row ${recommendCss["dash-info"]}`}>
                        <div className='col-lg-4 px-lg-1 mb-3 mb-lg-0'>
                            <div className={`${recommendCss["card"]} card h-100 ${recommendCss["line-primary"]} line-primary`}>
                                <div className={`${recommendCss["card-body"]} card-body`}>
                                    <h4><span className="material-symbols-rounded">payments</span>보유머니</h4>
                                    <div className={`${recommendCss["cash-amount"]} card-body h-100`}>
                                        <div>
                                            <span className='fs-1'>{stringUtil.formatNumber(cashAmount)}</span>
                                            <small className='fs-1'> P</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 pe-lg-1'>
                            <div className={`${recommendCss["card"]} card mb-3 line-teal ${recommendCss["line-teal"]}`}>
                                <div className={`${recommendCss["card-body"]}`}>
                                    <h4><span className="material-symbols-rounded">chat</span>발송 가능 건수 (이미지, 텍스트)</h4>
                                    <div className={`${recommendCss["row"]} row`}>
                                        <div className='col-sm-6 border-sm-end'>
                                            <span className="material-symbols-rounded fs-4 me-1">image</span>
                                            <span className={Math.floor((cashAmount+freeAmount)/imgMessageUnit) > 1000 ? 'fs-3' : 'fs-3 text-danger'}>{stringUtil.formatNumber(Math.floor((cashAmount+freeAmount)/imgMessageUnit))}</span>
                                            <small>건</small>
                                        </div>
                                        <div className='col-sm-6'>
                                            <span className="material-symbols-rounded fs-4 me-1">article</span>
                                            <span className={Math.floor((cashAmount+freeAmount)/txtMessageUnit) > 1000 ? 'fs-3' : 'fs-3 text-danger'}>{stringUtil.formatNumber(Math.floor((cashAmount+freeAmount)/txtMessageUnit))}</span>
                                            <small>건</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${recommendCss["card"]} card ${recommendCss["line-orange"]} mb-3 mb-lg-0`}>
                                <div className={`${recommendCss["card-body"]}  card-body`}>
                                    <h4><span className="material-symbols-rounded">forum</span>잔여 무료 포인트</h4>
                                    <div className='fs-3 text-center'>
                                        <span className='fs-3'>{stringUtil.formatNumber(freeAmount)}</span>
                                        <span className='fs-5'> P</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 pe-lg-1'>
                            <div className={`${recommendCss["card"]} card mb-3 ${recommendCss["line-green"]} line-green`}>
                                <div className={`${recommendCss["card-body"]}  card-body`}>
                                    <h4>
                                        <span className="material-symbols-rounded">new_releases</span>보유 쿠폰
                                    </h4>
                                    <div className='text-center'>
                                        <span className='fs-3 fw-medium'>{stringUtil.formatNumber(couponList.length)}</span>
                                        <span className='fs-5'> 장</span>
                                    </div>
                                </div>
                            </div>

                            <div className={`${recommendCss["card"]} card ${recommendCss["line-sky"]} line-sky`}>
                                <div className={`${recommendCss["card-body"]} card-body`}>
                                    <h4>
                                        <Tooltip title={"발송하고자 하는 타겟팅 대상을 설정하여 발송 가능 인원을 확인할 수 있습니다"}>
                                            <div className='d-flex align-items-center pointer'>
                                                <span className="material-symbols-rounded">groups</span>
                                                발송 가능 대상
                                                <span className="material-symbols-rounded fs-5 ps-1">info</span>
                                                <button className='btn btn-info btn-sm text-info' onClick={() => openMosuSelectModal("INIT")}>확인</button>
                                            </div>
                                        </Tooltip>
                                    </h4>
                                    <div className='mt-3 bg-light form-control px-2 py-1 rounded text-center'>
                                        <span className='fs-4 fw-medium'>{stringUtil.formatNumber(mosuCntInit)}</span>
                                        <span className='fs-5'>명</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className='mt-4 phone-slider'>
                        <div className='card'>
                            <div className='card-header d-flex'>
                                <Tooltip title={"검수 없이 간단한 업체 정보 입력만으로 발송 가능한 메시지 목록입니다."}>
                                    <label className='pointer'>
                                        <div className='d-inline-flex align-items-center'>
                                            <h4 className='fs-4'>발송 가능 메시지</h4>
                                            <span className="material-symbols-rounded fs-5 text-primary ps-2">info</span>
                                        </div>
                                    </label>
                                </Tooltip>
                                <select
                                    className="form-select categoty-select-list"
                                    value={JSON.stringify(bgmType)}
                                    onChange={(e) => setValue("bgmType", e.target.value)}
                                >
                                    <option value="">기본 메시지 업종 선택</option>
                                    {bgmTypeList?.map((item) => (
                                        <option key={item.uid} value={JSON.stringify(item)}>{item.name}</option>
                                    ))}
                                </select>
                                <select
                                    className="form-select categoty-select-list"
                                    value={JSON.stringify(gmType)}
                                    onChange={(e) => setValue("gmType", e.target.value)}
                                >
                                    <option value="">기본 메시지 카테고리 선택</option>
                                    {gmTypeList
                                        .filter((item) => (item.baseCategoryUid === bgmType?.uid))
                                        ?.map((item) => (
                                        <option key={item.uid} value={JSON.stringify(item)}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='card-body overflow-hidden position-relative'>
                                {
                                    groupedMessages.length !== 0 ?
                                        <Swiper
                                            modules={[Navigation]}
                                            slidesPerView={1}
                                            slidesPerGroup={1}
                                            spaceBetween={30}
                                            navigation
                                            breakpoints={{
                                                990: {
                                                    slidesPerView: 3,
                                                    slidesPerGroup: 3,
                                                    spaceBetween: 10,
                                                }
                                            }}
                                        >
                                            {
                                                groupedMessages.map((group, groupIndex) => (
                                                    <SwiperSlide key={groupIndex}>
                                                        <div className={`${recommendCss["phone-box"]}`}>
                                                            <div className={`${recommendCss["title"]}`}>
                                                                {group.name}
                                                                <small className={`${recommendCss["small"]}`}>미리보기</small>
                                                            </div>
                                                            <div className={`${recommendCss["phone-body"]} p-2`}>
                                                                <h5>{group.rcsTitle}</h5>
                                                                <div className={`text-area ${recommendCss["text-area"]}`} dangerouslySetInnerHTML={{__html: stringUtil.convertNewlineToBr(group.rcsMessage)}}/>
                                                            </div>
                                                            <div className='footer-btn pt-3 d-flex justify-content-center'>
                                                                <button className='btn btn-primary d-flex align-items-center' onClick={() => messageSelect(group)}>
                                                                    <span>문구 적고 발송하기</span>
                                                                    <span className="material-symbols-rounded">arrow_downward_alt</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ))
                                            }
                                        </Swiper>
                                        :
                                        <div className={"text-center vh-75"}>
                                            NO DATA YET
                                        </div>
                                }
                            </div>
                        </div>
                    </section>

                    {
                        messageDetail.uid > 0 &&
                        <section ref={this.detailsRef} className={`message-details-setting ${recommendCss["message-details-setting"]}`}>
                            <hr className='my-4'></hr>
                            <h4 className='fs-5 pb-0 justify-content-center d-flex align-items-center text-primary'>
                                문구적고 발송하기
                                <span className="material-symbols-rounded">arrow_downward_alt</span>
                            </h4>
                            <div className='card'>
                                <div className='card-header'>
                                    <h4 className='fs-4'>메시지 상세 설정</h4>
                                </div>
                                <div className='card-body border-bottom'>
                                    <div className={`row`}>
                                        <div className={`col-lg-12`}>
                                            <ul className={`${recommendCss["target-detail"]}`}>
                                                <li>
                                                    <label className="d-flex align-items-center has-before">타겟팅 조건</label>
                                                    <RadioBtnList
                                                        id="targetType"
                                                        list={[
                                                            { label: '일반 타겟팅', value: 'ATS'},
                                                            { label: '체류 위치 타겟팅', value: 'MAPTICS'},
                                                        ]}
                                                        value={targetType}
                                                        onChange={setValue}
                                                    />
                                                </li>
                                                <li>
                                                    <label className="d-flex align-items-center">목표 발송 건수 &#40;건&#41;
                                                        {
                                                            targetType !== 'ATS' && (sendNumber < 1000 || sendNumber > 100000) &&
                                                            <Tooltip title={
                                                                <div>
                                                                    <p className={"mb-0"}>최소 1000 (천) 건</p>
                                                                    <p className={"mb-0"}>최대 100000 (10만) 건</p>
                                                                    <p>으로 등록 하셔야합니다.</p>
                                                                </div>
                                                            }>
                                                                <span className="material-symbols-rounded fs-5 ps-1" style={{color: 'red'}}>info</span>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            targetType === 'ATS' && (sendNumber > 100000) &&
                                                            <Tooltip title={
                                                                <div>
                                                                    <p className={"mb-0"}>최대 100000 (10만) 건</p>
                                                                    <p>으로 등록 하셔야합니다.</p>
                                                                </div>
                                                            }>
                                                                <span className="material-symbols-rounded fs-5 ps-1" style={{color: 'red'}}>info</span>
                                                            </Tooltip>
                                                        }
                                                    </label>

                                                    <TextInput
                                                        id="sendNumber"
                                                        type="number"
                                                        name="sendNumber"
                                                        value={Number(sendNumber).toString()}
                                                        onChange={setValue}
                                                    />
                                                </li>
                                                {
                                                    targetType === "ATS" &&
                                                    <>
                                                        <li>
                                                            <label>목표 발송 일정</label>
                                                            <CampaignDateTimeInput
                                                                className={'form-control'}
                                                                inputName="sendDate"
                                                                value={sendDate}
                                                                minDate={scheduleLimits.sendDate.minDate}
                                                                maxTime="20:00"
                                                                onChange={setValue}
                                                            />
                                                        </li>
                                                        <li>
                                                            <label>목표 발송 대상</label>
                                                            <div className="d-flex flex-column flex-md-row">
                                                                <button className='btn btn-primary btn-sm me-1' onClick={() => openMosuSelectModal("RESET")}>조회</button>
                                                                <div>
                                                                    <TextInput
                                                                        id="sendNumber"
                                                                        type="text"
                                                                        name="mosuCnt"
                                                                        value={stringUtil.formatNumber(mosuCnt)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </>
                                                }
                                                {
                                                    targetType === "MAPTICS" &&
                                                    <>
                                                        <li>
                                                            <label>지오펜스 그리기</label>
                                                            <SingleButton
                                                                className="btn btn-sm btn-primary"
                                                                label="그리기"
                                                                handleClick={handleMapticsModal}
                                                            />
                                                        </li>
                                                        <li>
                                                            <label>발송 유형</label>
                                                            <SelectList
                                                                id="mapticsSendType"
                                                                className="form-select d-inline me-0 me-sm-2"
                                                                list={[
                                                                    { label: '모아서 보내기', value: 'maptics_collect'},
                                                                    { label: '실시간 보내기', value: 'maptics_realtime'},
                                                                ]}
                                                                value={mapticsSendType}
                                                                onChange={setValue}
                                                                disableDefault={true}
                                                            />
                                                        </li>
                                                        {
                                                            mapticsSendType === "maptics_collect" &&
                                                            <>
                                                                <li>
                                                                    <label>발송 일정</label>
                                                                    <CampaignDateTimeInput
                                                                        className={'form-control'}
                                                                        inputName="collSndDate"
                                                                        value={collSndDate}
                                                                        minDate={scheduleLimits.collSndDate.minDate}
                                                                        hourList={dateUtil.hourListForMapticsSchedule}
                                                                        maxTime="20:00"
                                                                        onChange={setValue}
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <label>수집 기간</label>
                                                                    <div
                                                                        className="d-flex"
                                                                    >
                                                                        <CampaignDateTimeInput
                                                                            className={'form-control'}
                                                                            inputName="collStartDate"
                                                                            value={collStartDate}
                                                                            minDate={scheduleLimits.collStartDate.minDate}
                                                                            hourList={dateUtil.hourListForMapticsCollect}
                                                                            maxDate={scheduleLimits.collStartDate.maxDate}
                                                                            maxDateTime={scheduleLimits.collStartDate.maxDateTime}
                                                                            onChange={setValue}
                                                                        />
                                                                        <span className="mt-1 mx-1"> ~ </span>
                                                                        <CampaignDateTimeInput
                                                                            className={'form-control'}
                                                                            inputName="collEndDate"
                                                                            value={collEndDate}
                                                                            minDate={scheduleLimits.collEndDate.minDate}
                                                                            hourList={dateUtil.hourListForMapticsCollect}
                                                                            maxDate={scheduleLimits.collEndDate.maxDate}
                                                                            maxDateTime={scheduleLimits.collEndDate.maxDateTime}
                                                                            onChange={setValue}
                                                                        />
                                                                    </div>
                                                                </li>
                                                            </>
                                                        }
                                                        {
                                                            mapticsSendType === "maptics_realtime" &&
                                                            <>
                                                                <li>
                                                                    <label>발송 기간</label>
                                                                    <div className='d-flex align-items-center v-align-custom'>
                                                                        <CampaignDateTimeInput
                                                                            className={'form-control'}
                                                                            inputName="collStartDate"
                                                                            value={collStartDate}
                                                                            minDate={scheduleLimits.collStartDate.minDate}
                                                                            hourList={dateUtil.hourListForMapticsSend}
                                                                            onChange={setValue}
                                                                        />
                                                                        &nbsp;&nbsp;~&nbsp;&nbsp;
                                                                        <div className={'d-flex'}>
                                                                            <SelectList
                                                                                className="form-select d-inline w-auto"
                                                                                id="rtEndHour"
                                                                                value={rtEndHour}
                                                                                list={dateUtil.hourListForMapticsSend}
                                                                                onChange={setValue}
                                                                                disableDefault={true}
                                                                            />
                                                                            <span className='mt-1 mx-1'>시</span>
                                                                            <SelectList
                                                                                className="form-select d-inline w-auto"
                                                                                id="rtEndMinute"
                                                                                value={rtEndMinute}
                                                                                list={dateUtil.minuteList}
                                                                                onChange={setValue}
                                                                                disableDefault={true}
                                                                            />
                                                                            <span className='mt-1 mx-1'>분</span>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className='card-header border-bottom-0'>
                                    <h4 className='fs-4'>메시지 문구 입력</h4>
                                </div>
                                <div className="card-body border-bottom pt-2">
                                    <div className="row">
                                        <div className="col-lg-4 pb-sm-0 pb-3">
                                            <div className={`${recommendCss["phone-box"]}`}>
                                                <div className={`${recommendCss["title"]}`}>
                                                    <h5>{messageDetail.name}</h5>
                                                    <small>미리보기</small>
                                                </div>
                                                <div className={`${recommendCss["phone-body"]} p-2`}>
                                                    {
                                                        RCSType !== "텍스트" &&
                                                        <div>
                                                            <h6 className={'text-center' + (preview !== null ? ' visually-hidden' : '')}>화면을 클릭해 <br/> 이미지를 선택하세요.</h6>
                                                            <img
                                                                className={preview !== null ? '' : 'icon_plus'}
                                                                src={preview !== null ? preview : "../../assets/img/img_plus.png"}
                                                                alt={"이미지"}
                                                                onClick={() => openImageListModal()}
                                                            />
                                                        </div>
                                                    }
                                                    <h5 dangerouslySetInnerHTML={{__html: messageDetail.rcsTitle ? stringUtil.convertNewlineToBr(stringUtil.renderMessage(messageDetail.rcsTitle, variableMap, urlMap)) : ''}}></h5>
                                                    <div className={`${recommendCss["text-area"]}`} dangerouslySetInnerHTML={{__html: messageDetail.rcsMessage ? stringUtil.convertNewlineToBr(stringUtil.renderMessage(messageDetail.rcsMessage, variableMap, urlMap)) : ''}}></div>
                                                    <div className={`${recommendCss["btn-area"]}`}>
                                                        {
                                                            buttonInfo.map((item, index) => (
                                                                <button key={index} className={index === 0 ? "btn btn-light btn-sm w-100 my-2" : "btn btn-light btn-sm w-100 mb-2"}>
                                                                    {item.name}
                                                                </button>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`col-lg-8 pe-md-5 ps-4 ${recommendCss["var-area"]}`}>
                                            <h5 className='d-flex align-items-center'>발송 유형
                                                <Tooltip title={
                                                    <div>
                                                        <p className='fw-bold mb-1'>통합유형이란?</p>
                                                        <p className='mb-0'>아이폰과 안드로이드 모두 RCS 타입으로 발송할 수 있는 유형입니다. 통합유형이 아닌 경우에는 안드로이드에서만 RCS 발송이 가능합니다</p>
                                                    </div>
                                                }>
                                                    <button type='button' className='btn btn-link p-0 border-0 d-inline-flex align-items-center' aria-label='통합유형 안내'>
                                                        <span className='material-symbols-rounded fs-5 ps-2 text-primary' aria-hidden='true'>info</span>
                                                    </button>
                                                </Tooltip>
                                            </h5>
                                            <select className="form-select mb-2" value={this.props.rcsType} onChange={e => handleRCSTypeChange('RCSType', e.target.value)}>
                                                {RCS_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
                                            </select>
                                            {
                                                RCSType === '이미지' &&
                                                <div className='row pe-0'>
                                                    <div className='pe-0 pb-3 pt-2'>
                                                        <span className="fs-7 text-muted d-block">
                                                            * 등록 가능한 이미지 파일 형식은 <strong>jpg, jpeg</strong>뿐입니다. 다른 형식의 파일은 등록할 수 없습니다.
                                                        </span>
                                                        <span className="fs-7 text-muted">
                                                            * AI 기본법에 따라 AI로 생성한 이미지는 반드시 체크해 주세요. 체크 시 메시지에 AI 생성 이미지 안내 문구가 자동으로 포함됩니다.
                                                        </span>
                                                        <div className="form-check mt-2">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id="isAIImage"
                                                                checked={isAIImage}
                                                                onChange={(e) => setIsAIImage(e.target.checked)}
                                                            />
                                                            <label className="form-check-label" htmlFor="isAIImage">
                                                                AI 생성 이미지 여부
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {/*3e 에 해당하는 메인 이미지 관련 내용*/}
                                            {
                                                RCSType === "이미지" &&
                                                <>
                                                    <h5 className="mt-2">메인 이미지</h5>
                                                    <div className='file-upload-area'>
                                                        <div className="input-group">
                                                            <button
                                                                className="btn btn-sm btn-primary rounded d-flex align-items-center me-2"
                                                                onClick={openImageListModal}
                                                            >
                                                                <span className="material-symbols-rounded fs-5 me-2">photo_library</span>불러오기
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-primary rounded d-flex align-items-center"
                                                                onClick={handleImageUploadModal}
                                                            >
                                                                <span className="material-symbols-rounded fs-5 me-2">upload_file</span>업로드
                                                            </button>
                                                        </div>
                                                        <p className='fs-6 fw-normal text-muted'>파일유형 : <strong>jpg/jpeg</strong> | {rcsSizeLabel(this.props.rcsType)}px ({rcsImageSizeLimitLabel(this.props.rcsType)})</p>
                                                    </div>
                                                </>
                                            }
                                            <h5 className="mt-2">변수 입력
                                                <small className="fs-6 ps-1 text-success">(미리보기 적용)</small>
                                                <span className='text-danger'>*</span>
                                            </h5>
                                            <div className='row m-0 pb-4'>
                                                {
                                                    Object.keys(variableMap).map((key, index) => (
                                                        !key.endsWith("기간") ?
                                                        <div className={"col-md-4"} key={index}>
                                                            <div className='row me-2'>
                                                                <label className={`px-0`}>변수 {index + 1}. {key}</label>
                                                                <TextInput
                                                                    id={key}
                                                                    type="text"
                                                                    value={variableMap[key]}
                                                                    onChange={setVariable}
                                                                    placeholder={key.endsWith("번호") ? '0000-0000 형식으로 입력' : ''}
                                                                />
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className={"px-0 my-2"} key={index}>
                                                            <label className={`px-0`}>변수 {index + 1}. {key}</label>
                                                            <RecommendDateInput
                                                                id={key}
                                                                setVariable={setVariable}
                                                                sendDate={sendDate}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                            <h5>URL
                                                <small className="fs-6 ps-1 text-success">(이벤트 도메인)</small>
                                                <span className='text-danger'>*</span>
                                                <span>
                                                    <Tooltip title="메시지 내 포함될 URL을 입력해주세요. 입력한 URL을 기준으로 반응률이 측정됩니다.">
                                                        <span className="material-symbols-rounded fs-5 text-primary ms-1">info</span>
                                                    </Tooltip>
                                                </span>
                                            </h5>
                                            <div className="row m-0 pb-4">
                                                {
                                                    Object.keys(urlMap).map((key, index) => (
                                                        <div className={"col-md-4"} key={index}>
                                                            <div className='row me-lg-2'>
                                                                <label className={`px-0`}>{key}</label>
                                                                <TextInput
                                                                    id={key}
                                                                    type="text"
                                                                    value={urlMap[key]}
                                                                    onChange={setUrl}
                                                                />
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                            <h5>버튼 추가
                                                <span>
                                                    <Tooltip title={<p>버튼은 RCS 메시지에만 포함되어 발송 됩니다.</p>}>
                                                        <span className="material-symbols-rounded fs-5 text-primary ms-1">info</span>
                                                    </Tooltip>
                                                </span>
                                            </h5>

                                            <ButtonCountComp setButtonCount={setButtonCount}/>
                                            {
                                                buttonCount.length !== 0 &&
                                                <div className='table-responsive'>
                                                    <table className={`table`}>
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th scope="col">NO</th>
                                                                <th scope="col">타입</th>
                                                                <th scope="col">버튼명</th>
                                                                <th scope="col">입력 값</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            buttonInfo.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td className='v-align-top'>
                                                                            <SelectList
                                                                                className='form-select'
                                                                                id={"type_" + index}
                                                                                list={messageUtil.btnTypeList}
                                                                                value={item.type}
                                                                                onChange={setButtonInfo}
                                                                                disableDefault={true}
                                                                            />
                                                                        </td>
                                                                        <td className='v-align-top'>
                                                                            <TextInput
                                                                                placeholder="버튼 명"
                                                                                className='form-control'
                                                                                id={"name_" + index}
                                                                                type="text"
                                                                                value={item.name}
                                                                                onChange={setButtonInfo}
                                                                            />
                                                                        </td>
                                                                        <td className='v-align-top'>
                                                                            {
                                                                                item.type === "WEB" &&
                                                                                <TextInput
                                                                                    placeholder="URL 주소 입력"
                                                                                    className='form-control'
                                                                                    id={"val1_" + index}
                                                                                    type="text"
                                                                                    value={item.val1}
                                                                                    onChange={setButtonInfo}
                                                                                />
                                                                            }
                                                                            {
                                                                                item.type === "PHONE" &&
                                                                                <TextInput
                                                                                    placeholder="전화번호 입력"
                                                                                    className='form-control'
                                                                                    id={"val1_" + index}
                                                                                    type="text"
                                                                                    value={item.val1}
                                                                                    onChange={setButtonInfo}
                                                                                />
                                                                            }
                                                                            {
                                                                                item.type === "MAP" &&
                                                                                (<>
                                                                                    <TextInput
                                                                                        placeholder="위치 이름을 입력"
                                                                                        className='form-control mb-1'
                                                                                        id={"val1_" + index}
                                                                                        type="text"
                                                                                        value={item.val1}
                                                                                        onChange={setButtonInfo}
                                                                                    />
                                                                                    <TextInput
                                                                                        placeholder="검색 URL 입력"
                                                                                        className='form-control mb-1'
                                                                                        id={"val2_" + index}
                                                                                        type="text"
                                                                                        value={item.val2}
                                                                                        onChange={setButtonInfo}
                                                                                    />
                                                                                </>)
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='card-header border-bottom-0 d-flex'>
                                    <h4 className='fs-4 me-2'>예상 차감 금액</h4>
                                    <button className='btn btn-primary btn-sm' onClick={()=>{window.location.href="/cash/charge"}}>충전</button>
                                </div>
                                <CouponChargeComp
                                    couponList={couponList}
                                    selectedCoupon={selectedCoupon}
                                    cashAmount={cashAmount}
                                    freeAmount={freeAmount}
                                    sndGoalCnt={sendNumber}
                                    billingType={billingType}
                                    txtMessageUnit={txtMessageUnit}
                                    imgMessageUnit={imgMessageUnit}
                                    handleCouponChange={handleCouponChange}
                                />
                                <div className='text-center py-4 pt-lg-4'>
                                    <button className={`${recommendCss["btn"]} btn btn-md btn-primary`} onClick={checkAtsMosuAndCreate}>저장</button>
                                </div>
                            </div>
                        </section>
                    }
                </div>
                <MessageMosuSelectModal
                    isOpen={mosuSelectModalOpen}
                    handleClose={handleMosuSelectModal}
                    setMosuData={setMosuData}
                />
                <MessageMapticsModal
                    isOpen={mapticsModalOpen}
                    handleClose={handleMapticsModal}
                    setMapticsData={setMapticsData}
                />
                <MessageSavedModal
                    open={savedModalOpen}
                    isClose={handleSavedModal}
                    type="recommend"
                    campaignUid={createdCampaignUid}
                    isRemind={true}
                />
                <ImageSelectModal
                    key={this.props.rcsType}
                    clearFile={()=>{
                        RecommendAction.setRCSFile(0, null);
                        RecommendAction.setMMSFile(null);
                        this.clearFileInput();
                    }}
                    changePreview={changePreview}
                    SelfAction={RecommendAction}
                    MTYPE={"RCS"}
                    isOpen={imageListModal}
                    isClose={closeImageListModal}
                    index={0}
                    handleChangePage={handlePageChange}
                    imageList={imageList}
                    total={total}
                    size={size}
                    page={page}
                />
                <ImageAddModal
                    key={this.props.rcsType}
                    rcsType={this.props.rcsType}
                    isOpen={imageUploadModal}
                    handleClose={handleImageUploadModal}
                    setValue={handleCPInput}
                    imgUploadAction={checkFileName}
                    imgType="RCS"
                    imgName={imgName}
                />
            </React.Fragment>
        )
    }
}

export default connect(
    (state) => ({
        mosuCntInit: state.recommend.get('mosuCntInit'),
        mosuCnt: state.recommend.get('mosuCnt'),
        mosuQuery: state.recommend.get('mosuQuery'),
        mosuDesc: state.recommend.get('mosuDesc'),
        mosuJson: state.recommend.get('mosuJson'),

        targetType: state.recommend.get('targetType'),
        mapticsSendType: state.recommend.get('mapticsSendType'),
        collStartDate: state.recommend.get('collStartDate'),
        collEndDate: state.recommend.get('collEndDate'),
        collSndDate: state.recommend.get('collSndDate'),
        rtEndHour: state.recommend.get('rtEndHour'),
        rtEndMinute: state.recommend.get('rtEndMinute'),
        mapticsData: state.recommend.get('mapticsData'),
        mapticsTargetId: state.recommend.get('mapticsTargetId'),

        couponList: state.recommend.get('couponList'),
        selectedCoupon: state.recommend.get('selectedCoupon'),
        cashAmount: state.recommend.get('cashAmount'),
        freeAmount: state.recommend.get('freeAmount'),
        txtMessageUnit: state.recommend.get('txtMessageUnit'),
        imgMessageUnit: state.recommend.get('imgMessageUnit'),

        gmType: state.recommend.get('gmType'),
        gmTypeList: state.recommend.get('gmTypeList'),
        bgmTypeList: state.recommend.get('bgmTypeList'),
        bgmType: state.recommend.get('bgmType'),
        groupedMessages: state.recommend.get('groupedMessages'),
        page: state.recommend.get("page"),
        total: state.recommend.get('total'),
        size: state.recommend.get('size'),

        messageDetail: state.recommend.get('messageDetail'),
        sendNumber: state.recommend.get('sendNumber'),
        sendDate: state.recommend.get('sendDate'),
        sendType: state.recommend.get('sendType'),

        rcsType: state.recommend.get('rcsType'),
        billingType: state.recommend.get('billingType'),
        messageType: state.recommend.get('messageType'),
        RCSType: state.recommend.get('RCSType'),

        imgName: state.recommend.get('imgName'),
        rcsImgOrigId: state.recommend.get('rcsImgOrigId'),
        mmsImgOrigId: state.recommend.get('mmsImgOrigId'),
        RCSFile: state.recommend.get('RCSFile'),
        MMSFile: state.recommend.get('MMSFile'),

        variableMap: state.recommend.get('variableMap'),
        urlMap: state.recommend.get('urlMap'),

        buttonCount: state.recommend.get('buttonCount'),
        buttonInfo: state.recommend.get('buttonInfo'),

        createdCampaignUid: state.recommend.get('createdCampaignUid'),
    }),
    (dispatch) => ({
        RecommendAction: bindActionCreators(recommendAction, dispatch),
    })
)(RecommendContainer);
